var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHitText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 152,
    viewBox: "0 0 157 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.1709 12L80.7568 12L80.7568 7.07031L76.2334 7.07031L76.2334 12L73.8115 12L73.8115 0.578124L76.2334 0.578125L76.2334 5.05469L80.7568 5.05469L80.7568 0.578126L83.1709 0.578127L83.1709 12Z",
    fill: "#FAF84B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8034 12.3632L87.3207 1.04259L89.7247 1.33625L88.2074 12.6569L85.8034 12.3632Z",
    fill: "#FAF84B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5569 14.3237L94.2064 13.7399L96.6796 4.66462L93.6695 3.91699L94.1995 1.97229L102.57 4.05135L102.04 5.99605L99.0301 5.24841L96.5569 14.3237Z",
    fill: "#FAF84B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.247 27.0811L120.274 25.6896L123.291 21.791L119.595 19.1836L116.578 23.0822L114.599 21.6862L121.589 12.6534L123.568 14.0493L120.829 17.5896L124.525 20.1969L127.265 16.6567L129.237 18.0482L122.247 27.0811Z",
    fill: "#FAF84B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.113 28.7849L132.2 20.7194L133.988 22.3532L125.9 30.4188L124.113 28.7849Z",
    fill: "#FAF84B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.834 37.112L129.269 35.2638L136.714 29.516L134.71 27.1492L136.305 25.9175L141.88 32.4992L140.284 33.7309L138.28 31.3641L130.834 37.112Z",
    fill: "#FAF84B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.451 61.7943L142.712 59.4963L147.442 58.1084L146.056 53.8026L141.326 55.1905L140.584 52.8851L151.543 49.6694L152.285 51.9748L147.99 53.2351L149.376 57.541L153.672 56.2807L154.411 58.5786L143.451 61.7943Z",
    fill: "#FAF84B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143.795 63.9984L155.065 62.1416L155.496 64.5248L144.226 66.3817L143.795 63.9984Z",
    fill: "#FAF84B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.984 74.4246L144.874 72.0053L154.272 71.6135L154.13 68.5152L156.144 68.4313L156.538 77.0473L154.524 77.1312L154.383 74.0329L144.984 74.4246Z",
    fill: "#FAF84B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.562 101.411L140.396 99.1461L145.069 100.715L146.633 96.4704L141.96 94.9014L142.797 92.6288L153.625 96.2642L152.787 98.5368L148.544 97.112L146.98 101.357L151.224 102.781L150.39 105.047L139.562 101.411Z",
    fill: "#FAF84B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.397 103.361L148.696 108.299L147.569 110.443L137.269 105.504L138.397 103.361Z",
    fill: "#FAF84B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.825 112.352L134.221 110.373L142.133 115.46L143.921 112.926L145.617 114.016L140.645 121.064L138.95 119.974L140.737 117.439L132.825 112.352Z",
    fill: "#FAF84B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112.305 131.59L114.331 130.277L117.188 134.295L120.984 131.835L118.127 127.817L120.16 126.5L126.778 135.809L124.746 137.126L122.152 133.478L118.356 135.938L120.95 139.586L118.924 140.899L112.305 131.59Z",
    fill: "#FAF84B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.931 132.618L115.286 142.707L113.106 143.761L107.751 133.673L109.931 132.618Z",
    fill: "#FAF84B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.837 136.707L102.13 135.928L105.415 144.743L108.351 143.745L109.055 145.634L100.888 148.408L100.185 146.519L103.121 145.521L99.837 136.707Z",
    fill: "#FAF84B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1497 139.74L73.562 139.832L73.3555 144.757L77.8757 144.93L78.0821 140.005L80.5023 140.097L80.0239 151.509L77.6038 151.416L77.7913 146.944L73.2711 146.771L73.0836 151.244L70.6713 151.152L71.1497 139.74Z",
    fill: "#FAF84B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5353 139.282L66.5463 150.529L64.1553 150.143L66.1443 138.896L68.5353 139.282Z",
    fill: "#FAF84B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.87 136.915L60.1963 137.589L57.3479 146.554L60.327 147.416L59.7167 149.337L51.4321 146.938L52.0425 145.017L55.0216 145.88L57.87 136.915Z",
    fill: "#FAF84B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7212 123.188L34.6374 124.656L31.4652 128.429L35.0558 131.181L38.228 127.407L40.1504 128.88L32.8006 137.623L30.8782 136.15L33.7588 132.723L30.1682 129.972L27.2876 133.399L25.3714 131.931L32.7212 123.188Z",
    fill: "#FAF84B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9349 121.418L22.5318 129.154L20.8107 127.45L29.2139 119.714L30.9349 121.418Z",
    fill: "#FAF84B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5617 112.837L26.0509 114.747L18.384 120.197L20.2912 122.642L18.6483 123.81L13.3445 117.009L14.9875 115.841L16.8947 118.287L24.5617 112.837Z",
    fill: "#FAF84B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.994 87.6815L13.6375 90.0083L8.85739 91.2133L10.0632 95.5731L14.8434 94.368L15.489 96.7022L4.4136 99.4943L3.76799 97.1601L8.10875 96.0658L6.90292 91.706L2.56216 92.8003L1.91864 90.4736L12.994 87.6815Z",
    fill: "#FAF84B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.747 85.4686L1.41426 86.893L1.08342 84.4938L12.4161 83.0694L12.747 85.4686Z",
    fill: "#FAF84B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0023 75.0041L12.0116 77.426L2.60538 77.4586L2.61719 80.5602L0.601579 80.5672L0.568729 71.9422L2.58434 71.9352L2.59615 75.0368L12.0023 75.0041Z",
    fill: "#FAF84B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5626 48.2569L17.6351 50.4857L13.0259 48.7375L11.288 52.9138L15.8973 54.662L14.9669 56.898L4.28733 52.8475L5.21778 50.6115L9.40339 52.199L11.1412 48.0227L6.95562 46.4352L7.88307 44.2064L18.5626 48.2569Z",
    fill: "#FAF84B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8139 46.3491L9.71472 41.0137L10.9292 38.9184L21.0284 44.2537L19.8139 46.3491Z",
    fill: "#FAF84B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7535 37.5843L24.2784 39.5051L16.5726 34.1108L14.6834 36.5706L13.0321 35.4147L18.2857 28.5743L19.9369 29.7302L18.0477 32.19L25.7535 37.5843Z",
    fill: "#FAF84B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0512 19.151L44.9754 20.3834L42.2849 16.2526L38.3953 18.5618L41.0858 22.6926L39.0033 23.9289L32.7695 14.3582L34.852 13.1218L37.2952 16.8729L41.1848 14.5637L38.7416 10.8126L40.8174 9.58029L47.0512 19.151Z",
    fill: "#FAF84B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4725 18.2088L44.5367 7.90849L46.7561 6.93913L51.6919 17.2395L49.4725 18.2088Z",
    fill: "#FAF84B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7268 14.506L57.4052 15.1959L54.4891 6.25315L51.516 7.13671L50.8912 5.2204L59.1588 2.76333L59.7837 4.67964L56.8106 5.56321L59.7268 14.506Z",
    fill: "#FAF84B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitText);
export default __webpack_public_path__ + "static/media/hit-text.10b4d45c9a7e0f59556a635b11620f0b.svg";
export { ForwardRef as ReactComponent };